import { Locale } from '@/shared/types';

const getOnlineChatLink = (locale: Locale, page?: string) => {
  switch (locale) {
    case 'ru':
      switch (page) {
        case 'api':
          return '//code.jivo.ru/widget/d75yqWJdAi';
        case 'partners':
          return '//code.jivo.ru/widget/89qyUyQsBq';
        case 'cityscan':
          return '//code.jivo.ru/widget/Ose2eUBX2d';
        default:
          return '//code.jivo.ru/widget/gSgPH8nsw3';
      }
    case 'kz':
      return '//code.jivo.ru/widget/USeoGeLPdc';
    case 'am':
      switch (page) {
        case 'api':
          return '//code.jivo.ru/widget/1H1CSe30hb';
        default:
          return '//code.jivo.ru/widget/PKKNL5y7qq';
      }
    default:
      return '//code.jivo.ru/widget/C1Y5EU0SZA';
  }
};

export default getOnlineChatLink;
